<template>
    <div class="modal-window bds090">
        <header class="modal-header">
            <div class="tit" @dblclick="openSnapshot()">{{$i18nUtil.trans("message.DashboardSnapshot.001","과제 히스토리")}}</div>
        </header>
        
        <div class="modal-content">
            <div class="history">
                <div class="nodata" v-show="filterHistory.length == 0">
                    <div class="inner" v-if="updatedList.length != 0 ">
                        <div class="txt">
                          {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
                        </div>
                    </div>
                </div> 
                    
                <div class="date_wrap" > <!--  -->
                    <template v-for="(item , index ) in historyArray" >
                        <div class="task_box_day" v-if="item[0].historyDay == $moment().format('YYYY-MM-DD')" :key="'history_'+index">
                            <div class="nodat"></div>
                            <div class="day" @click="$event.target.parentElement.classList.toggle('active');">  
                                {{ $i18nUtil.trans("message.DashboardHistory.today","오늘") }}
                            </div> 
                            <HistoryData 
                            :updatedList="item"
                            :groupId="groupId"
                            :isSnapshot="true"></HistoryData> 
                        </div>

                        <div class="task_box_day active" v-if="item[0].historyDay == $moment().subtract(1, 'day').format('YYYY-MM-DD')" :key="'history_'+index"> 
                            <div class="nodat"></div>
                            <div class="day"  @click="$event.target.parentElement.classList.toggle('active');">  
                                {{ $i18nUtil.trans("message.DashboardHistory.yesterday","어제") }}
                            </div>  
                            <HistoryData 
                            :updatedList="item"
                            :groupId="groupId"
                            :isSnapshot="true"></HistoryData> 
                        </div>

                        <div class="task_box_day active" v-if="item[0].historyDay < $moment().subtract(1, 'day').format('YYYY-MM-DD')" :key="'history_'+index"> 
                            <div class="nodat"></div>
                            <div class="day"  @click="$event.target.parentElement.classList.toggle('active');">   
                                <!-- <momentAgo prefix="" suffix="전" :date="item[0].historyDay" lang="kr" ></momentAgo>  -->
                                {{$moment(item[0].historyDay).format('YYYY.MM.DD')}}
                            </div> 
                            <HistoryData 
                            :updatedList="item"
                            :groupId="groupId"
                            :isSnapshot="true"></HistoryData> 
                        </div>
                    </template>
                    <div class="btn_box txtc">
                      <!-- <button type="button" class="btn-more-ico_small1 down" >10건 더보기</button> -->
                      &nbsp;
                    </div>      
                </div><!--//date_wrap-->
            </div>

        </div>
    </div>
</template>
<script>
import Paging from "@/assets/css/board.css";
import HistoryData from "../detail/tab/history/HistoryData";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
    components: {
      HistoryData
    },
    data() {
        return {
          groupId : null,
          todayCnt: 0,
          updatedList:[],
          historyArray:[],

          filterHistory:[],
          noneRead:false,

          checkBookmark:false,

          //생성/수정 자
          regUserArr : [],
          regUserSelectedArr : [],
          regUserSelectedAll : true,

          //상세옵션
          optionSelectedArr:[],

          //상태 
          statusSelectedArr:[],

          categoryArr : [],
          categorySelectedArr : [],
          categorySelectedAll : true,

        };
    }, 
    mounted() {
        this.setGroupId(this.$route.params.groupId);
    },
    methods : {
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
      setGroupId(groupId){  
        this.groupId = groupId;
        this.getHistory(groupId);
      },
      getHistory(groupId){
		  
        let obj = this;
        let reqData = {};
        reqData.params ={
          groupId:groupId
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/history/getDashboardHistoryList";
        reqData.method = "post";
        //프로그레스바 시작 
        this.showLoadingbar();
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => { 
            //프로그레스바 종료
            obj.hideLoadingbar();
            if(res.errorCode == null){
              this.updatedList = res.result.paperList;
              this.filterHistory = res.result.paperList; 
              
              this.optionSelectedArr=[];
              this.optionSelectedArr.push("MY");
              this.optionSelectedArr.push("NORMAL");
              this.optionSelectedArr.push("RESTRICT");
              this.optionSelectedArr.push("SECRET");

              this.statusSelectedArr=[];
              this.statusSelectedArr.push('GOOD');
              this.statusSelectedArr.push('SO');
              this.statusSelectedArr.push('DELAY');
              this.statusSelectedArr.push('EXCEEDED');

              this.regUserArr =[];
              this.regUserSelectedArr=[];
              this.regUserSelectedAll=true;
              let regUsers = [];

              for(let k in this.updatedList){
                let userId = this.updatedList[k].regUserId;
                let userName =this.updatedList[k].regUserName; 
                if(regUsers.indexOf(userId) == -1){
                  let param = {
                    userId : userId,
                    userName : userName
                  }
                  regUsers.push(userId);
                  this.regUserArr.push(param);
                } 

                let lastUpdUserId = this.updatedList[k].lastUpdUserId;
                let lastUpdUserName = this.updatedList[k].lastUpdUserName;
                if(regUsers.indexOf(lastUpdUserId) == -1){
                  let param = {
                    userId : lastUpdUserId,
                    userName : lastUpdUserName
                  }
                  regUsers.push(lastUpdUserId);
                  this.regUserArr.push(param);
                } 
              }

              this.regUserArr.sort();
              regUsers.sort();
              this.regUserSelectedArr = regUsers;  

              this.categoryArr = [];
              this.categorySelectedArr = [];
              this.categorySelectedAll = true;

              let categoryMids = [];

              for(let k in this.updatedList){
                let categoryMid = this.updatedList[k].categoryMid;
                let categoryName =this.updatedList[k].categoryName; 
                if(categoryMids.indexOf(categoryMid) == -1){
                  let param = {
                    categoryMid : categoryMid,
                    categoryName : categoryName
                  }
                  categoryMids.push(categoryMid);
                  this.categoryArr.push(param);
                }  
              }
 
              this.categoryArr.sort();
              categoryMids.sort();
              this.categorySelectedArr = categoryMids;                 

              // categoryMid categoryName paperStatus regUserId regUserName 수정자 정보 요청 
              this.setHistory();  
            }else{
              console.log(res);
            } 
            		
          })
          .catch(function(err) {
            console.log(err);
          });
        },
        setHistory(){
          // 오늘날짜 데이터 없으면 데이터없음 표시
          // 그 외 날짜 데이터는 데이터 없으면 표시안됨 
          this.historyArray = [];
          let dateArray = [];
          let totalCnt = 0;
          let dataLength = this.filterHistory.length; 
         // console.log(dataLength);
          for (var i = 0; i < dataLength; i++) {
            this.filterHistory[i].historyDay == this.$moment().format("YYYY-MM-DD") ? (totalCnt += 1) : (totalCnt += 0);
            if(dateArray.indexOf(this.filterHistory[i].historyDay) == -1 ){
              dateArray.push(this.filterHistory[i].historyDay);
            }
          }
          this.todayCnt = totalCnt; 
          for(let k in dateArray){
            let array = [];
            const result = this.filterHistory.filter(function(history) {
              return history.historyDay == dateArray[k];
            });
            array = result;
            this.historyArray.push(array);
          }  
        },
        setFilter(){
          this.filterHistory = this.updatedList;

          // this.setCategoryFilter();

          // /* 상세 옵션 */
          // this.setOptionFilter();

          // /* 상태 */
          // this.setStatusFilter();

          // /* 생성/수정자 */
          // this.setRegUserFilter(); 

          if(this.noneRead){
            let result = this.filterHistory.filter(function(data){
              return data.readCount == null || data.readCount == 0;
            })
            this.filterHistory = result; 
          } 

          if(this.checkBookmark){
            let result = this.filterHistory.filter(function(data){
              return data.paperBookmarkId != null;
            })
            this.filterHistory = result; 
          } 

          //히스토리 데이터 세팅
          this.setHistory();
        },
        showNoneRead(){  
          // if(this.noneRead){
          //   let result = this.filterHistory.filter(function(data){
          //     return data.readCount == null || data.readCount == 0;
          //   })
          //   this.filterHistory = result;
          //   this.setHistory();
          // }else {
          //   this.filterHistory = this.updatedList; 
          //   this.setHistory();
          // } 
          this.setFilter();
        },
        showBookmark(){ 
          // if(this.checkBookmark){
          //   let result = this.updatedList.filter(function(data){
          //     return data.paperBookmarkId != null;
          //   })
          //   this.filterHistory = result;
          //   this.setHistory();
          // }else {
          //   this.filterHistory = this.updatedList;
          //   this.setHistory();
          // }
          this.setFilter();
        },
        selectedRegUserAll(){ 
          if(this.regUserSelectedAll){
            //전체 선택
            for(let k in this.regUserArr){
              this.regUserSelectedArr.push(this.regUserArr[k].userId);
            } 
          }else{
            //전체선택 해지
            this.regUserSelectedArr = [];
          }

          this.setFilter();
        },
        selectedRegUser(){
          let filter = event.target.value;

          if(this.regUserSelectedArr.indexOf(filter) == -1){ 
            this.regUserSelectedArr.push(filter);
          }else{ 
            this.regUserSelectedAll=false;
            this.regUserSelectedArr.splice(this.regUserSelectedArr.indexOf(filter),1);
          }

          if(this.regUserSelectedArr.length == this.regUserArr.length){
            this.regUserSelectedAll = true; 
          }

          this.setFilter();
        },
        setRegUserFilter(){
          let jsonString="[";
          for(let k in this.regUserSelectedArr){
            let filter = this.regUserSelectedArr[k]; 
            const result = this.filterHistory.filter(function(board){
              return board.regUserId == filter;
            }); 
            
            if(result.length != 0){
              let jsonResultString = JSON.stringify(result);
              jsonString += jsonResultString.substring(1,jsonResultString.length-1) +','; 
            }
          } 
          if(jsonString.length != 1){
            jsonString = jsonString.slice(0,-1)+"]";
          }else{
            jsonString="[]";
          }
          this.filterHistory = JSON.parse(jsonString); 
        },
        optionSelected(data){
          event.target.parentElement.classList.toggle("active"); 
          
          if(this.optionSelectedArr.indexOf(data) == -1){
            this.optionSelectedArr.push(data);
          }else{
            this.optionSelectedArr.splice(this.optionSelectedArr.indexOf(data),1);
          }
          this.setFilter();
        },
        setOptionFilter(){ 
          let jsonString="["; 
          
          for(let k in this.optionSelectedArr){
            let filter = this.optionSelectedArr[k]; 
            const result = this.filterHistory.filter(function(board){
              if(filter == "MY"){ 
                return board.regUserId = localStorage.getItem("userId");
              }else{// NORMAL, RESTRICT, SECRET
                return board.docGrade == filter;
              }
            }); 
            
            if(result.length != 0){
              let jsonResultString = JSON.stringify(result);
              jsonString += jsonResultString.substring(1,jsonResultString.length-1) +','; 
            }
          } 
          if(jsonString.length != 1){
            jsonString = jsonString.slice(0,-1)+"]";
          }else{
            jsonString="[]";
          }
          this.filterHistory = JSON.parse(jsonString);
        },
        statusSelectedAll(){ 

          if(this.statusSelectedArr.length == 4){
            let tag = event.target.parentElement.parentElement.childNodes;
            for(let k in tag){
              if(tag[k].nodeName == "LI"){
                tag[k].classList.remove("active");
              }
            }
            this.statusSelectedArr = [];
          }else{
            let tag = event.target.parentElement.parentElement.childNodes;
            for(let k in tag){
              if(tag[k].nodeName == "LI"){
                tag[k].classList.add("active");
              }
            }
            this.statusSelectedArr=[];
            this.statusSelectedArr.push('GOOD');
            this.statusSelectedArr.push('SO');
            this.statusSelectedArr.push('DELAY');
            this.statusSelectedArr.push('EXCEEDED');
          }

          this.setFilter();
        },
        fStatusSelectedArr(data){
          event.target.parentElement.classList.toggle("active"); 

          if(this.statusSelectedArr.indexOf(data) == -1){
            this.statusSelectedArr.push(data);
          }else{
            event.target.parentElement.parentElement.childNodes[0].classList.remove("active");
            this.statusSelectedArr.splice(this.statusSelectedArr.indexOf(data),1);
          }

          if(this.statusSelectedArr.length == 4){
            event.target.parentElement.parentElement.childNodes[0].classList.add("active"); 
          }

          this.setFilter();
        },
        setStatusFilter(){
          let jsonString="[";   
          for(let k in this.statusSelectedArr){
            let filter = this.statusSelectedArr[k]; 
            const result = this.filterHistory.filter(function(board){  
              return board.paperStatus == filter; 
            }); 
            
            if(result.length != 0){
              let jsonResultString = JSON.stringify(result);
              jsonString += jsonResultString.substring(1,jsonResultString.length-1) +','; 
            }
          } 
          if(jsonString.length != 1){
            jsonString = jsonString.slice(0,-1)+"]";
          }else{
            jsonString="[]";
          }
          this.filterHistory = JSON.parse(jsonString);
        },
        selectedCategoryAll(){ 
          if(this.categorySelectedAll){
            //전체 선택
            for(let k in this.categoryArr){
              this.categorySelectedArr.push(this.categoryArr[k].categoryMid);
            } 
          }else{
            //전체선택 해지
            this.categorySelectedArr = [];
          }

          this.setFilter();
          
        },
        selectedCategory(){
          let filter = event.target.value;

          if(this.categorySelectedArr.indexOf(filter) == -1){ 
            this.categorySelectedArr.push(filter);
          }else{ 
            this.categorySelectedAll=false;
            this.categorySelectedArr.splice(this.categorySelectedArr.indexOf(filter),1);
          }

          if(this.categorySelectedArr.length == this.categoryArr.length){
            this.categorySelectedAll = true; 
          }

          this.setFilter();
        },
        setCategoryFilter(){
          let jsonString="[";   
          for(let k in this.categorySelectedArr){
            let filter = this.categorySelectedArr[k]; 
            const result = this.filterHistory.filter(function(board){  
              return board.categoryMid == filter; 
            }); 
            
            if(result.length != 0){
              let jsonResultString = JSON.stringify(result);
              jsonString += jsonResultString.substring(1,jsonResultString.length-1) +','; 
            }
          } 
          if(jsonString.length != 1){
            jsonString = jsonString.slice(0,-1)+"]";
          }else{
            jsonString="[]";
          }
          this.filterHistory = JSON.parse(jsonString);
        },
        openSnapshot() {
            window.open(window.location.href, "_blank", "width=800, height=692");
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/snapshot/DashboardSnapshot.vue